import React, { useEffect, useState, useRef, MutableRefObject } from "react";
import '@hassanmojab/react-modern-calendar-datepicker/lib/DatePicker.css';
import DatePicker from '@hassanmojab/react-modern-calendar-datepicker';
import CustomDatePicker from "../date-picker/DatePicker";
import useBrowserMode from "../../../shared/hooks/useBrowserMode";
import contentfulRenderOptions from '../../../utils/contentfulRenderOption';
//Estilos
import "./FormInputAceleradora.scss";
import FormDragAndDropInput from "../form-drag-and-drop-input/FormDragAndDropInput";

interface IInputFormAceleradora {
    title: string;
    value: string;
    nombreId: string;
    textoTerminos: any;
    tituloBotonTerminos?: any;
    type:
        | "select"
        | "text"
        | "text-area"
        | "number"
        | "predict"
        | "date"
        | "checkbox"
        | "checkbox-parent"
        | "email"
        | "mobile"
        | "mobile-or-phone"
        | "radio"
        | "drag-and-drop"
        | "table-select"
        | "file";
    options?: Array<any>;
    maxLength?: number;
    isError?: boolean;
    errorMessage?: string;
    setCodeType?: any;
    setCodeTheme?: any;
    setCodeTypeDoc?: any;
    gigyaAccount?: any;
    placeholder?: any;
    setInputValue: any;
    checked?: boolean;
    isRequired?: boolean;
    disabled?: boolean;
    validBirthDate?: boolean;
    tabOrder?: string;
    dateState?: any;
    ayuda?: string;
    talleresData?: any;
    dateStateHelper?: boolean;
    setDateStateHelper?: any;
    labelContent?: any;
}


//locale custom para el date picker
const myCustomLocale = {
    // months list by order
    months: [
    'Enero',
    'Febrero',
    'Marzo',
    'Abril',
    'Mayo',
    'Junio',
    'Julio',
    'Agosto',
    'Septiembre',
    'Octubre',
    'Noviembre',
    'Diciembre',
    ],
  
    // week days by order
    weekDays: [
      {
        name: 'Domingo', // used for accessibility 
        short: 'S', // displayed at the top of days' rows
        isWeekend: true, // is it a formal weekend or not?
      },
      {
        name: 'Lunes',
        short: 'M',
      },
      {
        name: 'Martes',
        short: 'T',
      },
      {
        name: 'Miercoles',
        short: 'W',
      },
      {
        name: 'Jueves',
        short: 'T',
      },
      {
        name: 'Viernes',
        short: 'F',
      },
      {
        name: 'Sábado',
        short: 'S',
        isWeekend: true,
      },
    ],
  
    // just play around with this number between 0 and 6
    weekStartingIndex: 0,
  
    // return a { year: number, month: number, day: number } object
    getToday(gregorainTodayObject) {
      return gregorainTodayObject;
    },
  
    // return a native JavaScript date here
    toNativeDate(date) {
      return new Date(date.year, date.month - 1, date.day);
    },
  
    // return a number for date's month length
    getMonthLength(date) {
      return new Date(date.year, date.month, 0).getDate();
    },
  
    // return a transformed digit to your locale
    transformDigit(digit) {
      return digit;
    },
  
    // texts in the date picker
    nextMonth: 'Siguiente Mes',
    previousMonth: 'Anterior mes',
    openMonthSelector: 'Abrir selección de mes',
    openYearSelector: 'Abrir selección de año',
    closeMonthSelector: 'Cerrar selección de mes',
    closeYearSelector: 'Cerrar selección de año',
    defaultPlaceholder: 'Seleccionar...',
  
    // for input range value
    from: 'desde',
    to: 'hasta',
  
  
    // used for input value when multi dates are selected
    digitSeparator: ',',
  
    // if your provide -2 for example, year will be 2 digited
    yearLetterSkip: 0,
  
    // is your language rtl or ltr?
    isRtl: false,
  }

const FormInputAceleradora = (props: IInputFormAceleradora) => {
    const node: MutableRefObject<any> = useRef();

    const {
        title,
        value,
        nombreId,
        type,
        options,
        maxLength,
        isError,
        errorMessage,
        placeholder,
        textoTerminos,
        tituloBotonTerminos,
        setInputValue,
        checked,
        isRequired,
        disabled,
        tabOrder,
        dateState,
        ayuda,
        talleresData,
        dateStateHelper,
        setDateStateHelper,
        labelContent,
    } = props;

    const [isActive, setActiveSelect] = useState(false);
    const [isRadioOtherChecked, setIsRadioOtherChecked] = useState(false);
    const [radioOtherValue, setRadioOtherValue] = useState("");
    const [selectedDay, setSelectedDay] = useState(dateState);
    const [selectedWorkshop, setSelectedWorkshop] = useState({workshop: "",modality:""});
    const {document} = useBrowserMode();
    const [dateChanged, setDateChanged] = useState<boolean>(false);
   
    const [inputIsError, setInputIsError] = useState(false);

    //let inputTalleres = document.querySelector(".a-nombre-taller-input");
    //let inputModalidad = document.querySelector(".a-modalidad-taller-input");

    

    useEffect(() =>{
        
        /**if(inputTalleres != undefined && inputModalidad != undefined){
            console.log(inputTalleres);
            inputTalleres.checked = false;
            inputModalidad.checked = false;
        }**/
        setSelectedWorkshop({workshop: "",modality:""});
        
        
    }, [talleresData]);

    useEffect(() => {
        if (type == "radio") {
            if (
                (options || [])
                    .map((option) => {
                        return option.split("#")[0].split(":")[0] || option;
                    })
                    .includes(value)
            ) {
                setRadioOtherValue("");
                setIsRadioOtherChecked(false);
            } else {
                if (value != "") {
                    setRadioOtherValue(value);
                }
            }
        }

        if (type === "date" && !dateChanged) {
         setSelectedDay(value);
     }
    }, [value]);

    const handleClickOutside = (e) => {
        if (node.current.contains(e.target)) {
            return;
        } else {
            setActiveSelect(false);
        }
    };

    const handleSelectWorkshop = (e) => {
        setSelectedWorkshop({...selectedWorkshop, workshop:e.target.value});
        setInputValue(nombreId, selectedWorkshop.workshop+" "+e.target.value, type);
        alert(nombreId);
    }

    const handleSelectModality = (e) => {
        setSelectedWorkshop({...selectedWorkshop, modality:e.target.value});
        setInputValue(nombreId, selectedWorkshop.workshop+" "+e.target.value, type);
        alert(nombreId);
    }


    useEffect(() => {
        if (isActive) {
            document.addEventListener("mousedown", handleClickOutside);
        } else {
            document.removeEventListener("mousedown", handleClickOutside);
        }
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [isActive]);

    
    useEffect(() =>{
        const workshopSelected =document.getElementById(selectedWorkshop.workshop);
        const modalityPresencial = document.getElementById("presencial"+selectedWorkshop.workshop);
        const modalityVirtual = document.getElementById("virtual"+selectedWorkshop.workshop);
        
        if(workshopSelected != undefined ){
            if(workshopSelected.checked == true){
                modalityPresencial.checked = false;
                modalityVirtual.checked = false;
                setSelectedWorkshop({workshop: selectedWorkshop.workshop, modality:""});
            }
        }
        
    }, [])

    useEffect(() =>{
        const datePick = document.querySelector(".input-date-picker");
        datePick?.setAttribute("tabIndex", "8");
    }, [])

    useEffect(() =>{
        const datePick = document.querySelector(".input-date-picker-aceleradora");
        datePick?.setAttribute("id", "input-birth_date");
    }, [])

    useEffect (() => {
        if(dateStateHelper){
            setSelectedDay("");
            setDateStateHelper(false);
        }
    },[dateStateHelper])
    
    const handleKeyDown = (e) => {
        if (e.key === 'ArrowUp' || e.key === 'ArrowDown' || e.keyCode === 110 || e.keyCode ===190) e.preventDefault();
    }

    const preventNumberInput = (e) => {
        var keyCode = (e.keyCode ? e.keyCode : e.which);
        if (keyCode > 47 && keyCode < 58 || keyCode > 95 && keyCode < 107 ){
            e.preventDefault();
        }
    }

    const inputTypeComponent = () => {
        switch (type) {
            case "select":
                return (
                    <>
                        <label
                            id={"title-" + nombreId}
                            className={"a-input-aceleradora__form__title"}
                        >
                            {title}
                        </label>
                        <select
                            className={
                              `a-input-aceleradora__form a-input-aceleradora__form-select ${ !value ? "empty" : ""  }`
                            }
                            id={type + "_" + nombreId}
                            ref={node}
                            value={value}
                            onChange={(e) =>
                                setInputValue(nombreId, e.target.value, type)
                            }
                            disabled={ disabled }
                            tabIndex={parseInt(tabOrder!)}
                        >
                            <>
                                <option
                                    className="a-input-aceleradora__form a-input-aceleradora__form-select a-input-aceleradora__form-select--placeholder"
                                    key={0}
                                    value=""
                                >
                                    {placeholder || ""}
                                </option>
                                {(options || []).map((option, index) => {
                                    return (
                                        <option
                                            className="a-input-aceleradora__form a-input-aceleradora__form-select a-input-aceleradora__form-select--option"
                                            key={index}
                                            value={option}
                                        >
                                            {option}
                                        </option>
                                    );
                                })}
                            </>
                        </select>
                    </>
                );

            case "email":
                return (
                    <>
                        <label
                            id={"title-" + nombreId}
                            className={"a-input-aceleradora__form__title"}
                        >
                            {title}
                        </label>
                        {textoTerminos && (
                            <span className="a-input-aceleradora__form__texto-terminos">
                                {contentfulRenderOptions(
                                    textoTerminos.json
                                )}
                            </span>
                        )}
                        <input
                            className={`a-input-aceleradora__form__field${
                                isError ? " a-input-aceleradora__form__field--error" : ""
                            }`}
                            id={"input-" + nombreId}
                            name={title}
                            type={type}
                            value={value}
                            maxLength={nombreId === "idNum" ? 20 : 40}
                            onChange={(e) =>
                                setInputValue(nombreId, e.target.value, type)
                            }
                            placeholder={placeholder || ""}
                            disabled={ disabled }
                            tabIndex={parseInt(tabOrder!)}
                        />
                    </>
                );

            case "text":
                return (
                    <>
                        <label
                            id={"title-" + nombreId}
                            className={"a-input-aceleradora__form__title"}
                        >
                            {title}
                        </label>
                        {textoTerminos && (
                            <span className="a-input-aceleradora__form__texto-terminos">
                                {contentfulRenderOptions(
                                    textoTerminos.json, 
                                )}
                            </span>
                        )}
                        <input
                            className={`a-input-aceleradora__form__field${
                                isError ? " a-input-aceleradora__form__field--error" : ""
                            }`}
                            id={"input-" + nombreId}
                            name={title}
                            type={type}
                            onKeyDown={preventNumberInput}
                            value={value}
                            maxLength={nombreId === "idNum" ? 20 : 40}
                            onChange={(e) =>
                                setInputValue(nombreId, e.target.value, type)
                            }
                            placeholder={placeholder ? placeholder : ""}
                            disabled={ disabled }
                            tabIndex={parseInt(tabOrder!)}
                        />
                    </>
                );

            case "mobile":
                return (
                    <>
                        <label
                            id={"title-" + nombreId}
                            className={"a-input-aceleradora__form__title"}
                        >
                            {title}
                        </label>

                        {textoTerminos && (
                            <span className="a-input-aceleradora__form__texto-terminos">
                                {contentfulRenderOptions(
                                    textoTerminos.json,
                                )}
                            </span>
                        )}
                        <input
                            className={`a-input-aceleradora__form__field${
                                inputIsError ? " a-input-aceleradora__field--error" : ""
                            }`}
                            id={"input-" + nombreId}
                            name={title}
                            type="number"
                            maxLength={maxLength || 10}
                            value={value}
                            disabled={disabled}
                            tabIndex={parseInt(tabOrder!)}
                            placeholder={placeholder || ""}
                            onChange={(e) => {
                                const inputValue = e.target.value;

                                // Validación para "auxNumber"
                                if (["mobile", "auxNumber", "cellphone", "additionalCellphone", "contact_number"].includes(nombreId)) {
                                    // Validar y mostrar error si tiene menos de 10 caracteres
                                    if (inputValue.length < 10) {
                                        setInputIsError(true);
                                    } else {
                                        setInputIsError(false); // Ocultar error si cumple
                                    }

                                    // Restringir a un máximo de 10 caracteres sin bloquear el teclado
                                    if (inputValue.length > 10) {
                                        setInputValue(nombreId, inputValue.slice(0, 10), type);
                                        return;
                                    }
                                } else if (nombreId === "phone") {
                                    if (inputValue.length < 7) {
                                        setInputIsError(true);
                                    } else {
                                        setInputIsError(false); 
                                    }
                                    if (inputValue.length > 7) {
                                        setInputValue(nombreId, inputValue.slice(0, 7), type);
                                        return;
                                    }
                                }
                                
                                else {
                                    // Validación para otros campos (máximo 13 caracteres)
                                    if (inputValue.length > 13) {
                                        setInputValue(nombreId, inputValue.slice(0, 13), type);
                                        return;
                                    }
                                }

                                // Actualiza el valor del input
                                setInputValue(nombreId, inputValue, type);
                            }}
                            />
                              {/* Mensaje de error */}
                            {inputIsError && (
                            <span className="a-input__form__error-message">
                              * El número no es válido.
                            </span>
                            )}
                    </>
                );

                case "mobile-or-phone":
                    return (
                        <>
                            <label
                                id={"title-" + nombreId}
                                className={"a-input-aceleradora__form__title"}
                            >
                                {title}
                            </label>
    
                            {textoTerminos && (
                                <span className="a-input-aceleradora__form__texto-terminos">
                                    {contentfulRenderOptions(
                                        textoTerminos.json,
                                    )}
                                </span>
                            )}
                            <input
                                className={`a-input-aceleradora__form__field${
                                    inputIsError ? " a-input-aceleradora__form__field--error" : ""
                                }`}
                                id={"input-" + nombreId}
                                name={title}
                                type="mobile"
                                maxLength={maxLength || 10}
                                value={value}
                                disabled={disabled}
                                tabIndex={parseInt(tabOrder!)}
                                placeholder={placeholder ? placeholder : ""}
                                onChange={(e) => {
                                    const inputValue = e.target.value;
    
                                    // Validación para "auxNumber"
                                    if (["mobile", "auxNumber", "cellphone", "additionalCellphone", "mobile_aux"].includes(nombreId)) {
                                        // Validar y mostrar error si tiene menos de 10 caracteres
                                        if (inputValue.length < 10) {
                                            setInputIsError(true);
                                        } else {
                                            setInputIsError(false); // Ocultar error si cumple
                                        }
    
                                        // Restringir a un máximo de 10 caracteres sin bloquear el teclado
                                        if (inputValue.length > 10) {
                                            setInputValue(nombreId, inputValue.slice(0, 10), type);
                                            return;
                                        }
                                    } else if (nombreId === "phone") {
                                        if (inputValue.length < 7) {
                                            setInputIsError(true);
                                        } else {
                                            setInputIsError(false); 
                                        }
                                        if (inputValue.length > 7) {
                                            setInputValue(nombreId, inputValue.slice(0, 7), type);
                                            return;
                                        }
                                    }
                                    
                                    else {
                                        // Validación para otros campos (máximo 13 caracteres)
                                        if (inputValue.length > 13) {
                                            setInputValue(nombreId, inputValue.slice(0, 13), type);
                                            return;
                                        }
                                    }
    
                                    // Actualiza el valor del input
                                    setInputValue(nombreId, inputValue, type);
                                }}
                                />
                                  {/* Mensaje de error */}
                                {inputIsError && (
                                <span className="a-input__form__error-message">
                                * El número no es válido.
                                </span>
                            )}
                        </>
                    );

            case "number":
                return (
                    <>
                        <label
                            id={"title-" + nombreId}
                            className={"a-input-aceleradora__form__title"}
                        >
                            {title}
                        </label>

                        {textoTerminos && (
                            <span className="a-input-aceleradora__form__texto-terminos">
                                {contentfulRenderOptions(
                                    textoTerminos.json,
                                )}
                            </span>
                        )}
                        <input
                            className={`a-input-aceleradora__form__field ${
                                isError ? "a-input-aceleradora__form__field--error" : ""
                            }`}
                            id={"input-" + nombreId}
                            name={title}
                            type="number"
                            onKeyDown={handleKeyDown}
                            onWheel={(e) => e.currentTarget.blur()}
                            value={value}
                            onChange={(e) =>
                                setInputValue(
                                    nombreId,
                                    e.target.value,
                                    type
                                )
                            }
                            disabled={ disabled }
                            tabIndex={parseInt(tabOrder!)}
                            placeholder={placeholder || ""}
                            />
                    </>
                );

            case "text-area":
                return (
                    <>
                        <label
                            id={"title-" + nombreId}
                            className={"a-input-aceleradora__form__title"}
                        >
                            {title}
                        </label>
                        {textoTerminos && (
                            <span className="a-input-aceleradora__form__texto-terminos">
                                {contentfulRenderOptions(
                                    textoTerminos.json
                                )}
                            </span>
                        )}
                        <textarea
                            className={`a-input-aceleradora__form__field${
                                isError ? " a-input-aceleradora__form__field--error" : ""
                            }`}
                            id={"text-area-" + nombreId}
                            name={title}
                            maxLength={300}
                            onChange={(e) =>
                                setInputValue(nombreId, e.target.value, type)
                            }
                            disabled={disabled}
                            tabIndex={parseInt(tabOrder!)}
                            rows={5}
                            cols={50}
                        />
                    </>
                );

            case "date":
               return (
                  <CustomDatePicker
                     nombreId={nombreId}
                     value={value}
                     title={title}
                     setInputValue={setInputValue}
                     type={type}
                     placeholder={placeholder}
                     setDateChanged={setDateChanged}
                  />
               )
            case "checkbox":
                return (
                    <>
                        <label
                            id={"title-" + nombreId}
                            className={"a-input-aceleradora__form__title"}
                        >
                            {title}
                        </label>

                        <div style={{ display: "flex" }}>
                            <input
                                className={`${
                                    isError
                                        ? " a-input-aceleradora__form__field--error"
                                        : ""
                                }`}
                                type="checkbox"
                                id={nombreId}
                                defaultChecked={checked}
                                checked={checked}
                                onChange={(e) =>
                                    setInputValue(
                                        nombreId,
                                        e.target.checked,
                                        type
                                    )
                                }
                                disabled={disabled}
                                tabIndex={parseInt(tabOrder!)}
                            />
                            <span style={{ paddingLeft: "10px" }}>
                                {tituloBotonTerminos}
                            </span>
                        </div>
                    </>
                );
            case "radio":
                return (
                    <>
                        <label
                            id={"title-" + nombreId}
                            className={"a-input-aceleradora__form__title"}
                        >
                            {title} {labelContent && labelContent}
                        </label>
                        <div className="a-input-aceleradora__form__field-note">{ayuda}</div>
                        <div className="radio-container-aceleradora" id={nombreId}>
                            {(options || []).map((option, _index) => {
                                return (
                                    <>
                                        <div
                                            className="radio-options"
                                            id={nombreId}
                                        >
                                            <input
                                                type="radio"
                                                className="radio-size"
                                                id={nombreId + "_" + option}
                                                name={nombreId}
                                                value={option ?? ""}
                                                defaultChecked={
                                                    option == props.value ||
                                                    isRadioOtherChecked
                                                }
                                                onChange={(e) => {
                                                    if (option == "Otro") {
                                                        setInputValue(
                                                            nombreId,
                                                            radioOtherValue,
                                                            type
                                                        );
                                                        setIsRadioOtherChecked(
                                                            true
                                                        );
                                                    } else {
                                                        setInputValue(
                                                            nombreId,
                                                            e.target.value,
                                                            type
                                                        );
                                                        setIsRadioOtherChecked(
                                                            false
                                                        );
                                                    }
                                                }}
                                                tabIndex={parseInt(tabOrder!)}
                                            />
                                            {option != "Otro" ? (
                                                <span>{option}</span>
                                            ) : (
                                                <>
                                                    <span>{option}</span>
                                                    <input
                                                        className={`bordered-radio__other-input ${
                                                            isRadioOtherChecked
                                                                ? "show"
                                                                : ""
                                                        } `}
                                                        type="text"
                                                        id={
                                                            nombreId +
                                                            "_" +
                                                            option
                                                        }
                                                        name={nombreId}
                                                        value={radioOtherValue}
                                                        disabled={
                                                            !isRadioOtherChecked
                                                        }
                                                        onChange={(e) => {
                                                            setInputValue(
                                                                nombreId,
                                                                e.target.value,
                                                                type
                                                            );
                                                            setRadioOtherValue(
                                                                e.target.value
                                                            );
                                                        }}
                                                        placeholder={"¿Cuál?"}
                                                    />
                                                </>
                                            )}
                                        </div>
                                    </>
                                );
                            })}
                        </div>
                    </>
                );

            case "drag-and-drop":
                return (
                    <>
                        <FormDragAndDropInput setInputValue={setInputValue} nombreId={nombreId} type={type}/>
                    </>
                );
            
            case "table-select":
                return(
                    <>
                        {talleresData &&(
                            <div>
                            <table className="table-select-aceleradora">
                                <tr>
                                    <th>Nombre del taller</th>
                                    <th>Duración</th>
                                    <th>Modalidad</th>
                                </tr>
                                {talleresData.data.map((item, index) => (
                                    <tr key={`input-aceleradora-table-select-${index}`}>
                                        <td className="input">
                                            <label>
                                            <input type="radio" name="talleres" value={item.taller} className="a-nombre-taller-input" onChange={handleSelectWorkshop} id={item.taller}/>
                                            {item.taller}
                                            </label>
                                        </td>
                                        <td>{item.duration}</td>
                                        <td className="modality">
                                            {item.presencial && (
                                                <label>
                                                    <input type="radio" name="modalidad" value={"Presencial"} className="a-modalidad-taller-input" onChange={handleSelectModality} id={`presencial-${item.taller}`}/>
                                                    Presencial
                                                </label>
                                            )}
                                            {item.virtual && (
                                                <label>
                                                    <input type="radio" name="modalidad" value={"Virtual"} className="a-modalidad-taller-input" onChange={handleSelectModality} id={`virtual-${item.taller}`}/>
                                                    Virtual
                                                </label>
                                            )}
                                        </td>
                                    </tr>
                                ))}
                            </table>
                        </div>
                        )}
                    </>
                );

            case "file":
                return (
                    <>
                        <label
                            id={"title-" + nombreId}
                            className={"a-input-aceleradora__form__title"}
                        >
                            {title}
                        </label>
                        <input
                            className={`a-input-aceleradora__form__field__attach${
                                isError ? " a-input-aceleradora__form__field--error" : ""
                            }`}
                            id={"input-" + nombreId}
                            name={title}
                            type={type}
                            value={value}
                            maxLength={nombreId === "idNum" ? 20 : 40}
                            onChange={(e) =>
                                setInputValue(nombreId, e.target.value, type, e)
                            }
                            accept=".jpg, .png, .pdf"
                            disabled={ disabled }
                            tabIndex={parseInt(tabOrder!)}
                        />
                    </>
                );
        }
    };

    return (
        <div
            className={`a-input-aceleradora__form a-input-aceleradora__form-${type} a-input-aceleradora__form-${nombreId} ${
                isRequired ? "a-input-aceleradora__form--required" : ""
            } gtmFormField-${nombreId}`}
        >
            {inputTypeComponent()}
            {isError && (
                <span className="a-input-aceleradora__form__title__error">
                    {errorMessage}
                </span>
            )}
        </div>
    );
};

export default FormInputAceleradora;
